<div class="container mt-3">
  <fgbcl-auction-list [defaultSort]="1"></fgbcl-auction-list>
</div>
